import types from "./types";

const initialState = {
  isGettingNameEnquiry: false,
  getNameEnquirySuccess: false,
  nameEnquiry: {},
  isLoading: false,

  sendMandateAdviceSuccess: false,
  sendMandateAdvice: {},

  sendBalanceEnquirySuccess: false,
  sendBalanceEnquiry: {},

  sendFundTransferDcSuccess: false,
  sendFundTransferDc: {},

  sendFundTransferAdviceDcSuccess: false,
  sendFundTransferAdviceDc: {},

  sendFundTransferDdSuccess: false,
  sendFundTransferDd: {},

  sendFundTransferAdviceDdSuccess: false,
  sendFundTransferAdviceDd: {},

  sendAmountBlockSuccess: false,
  sendAmountBlock: {},

  sendAccountBlockSuccess: false,
  sendAccountBlock: {},

  getFinancialListSuccess: false,
  getFinancialList: {},
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_NAME_ENQUIRY_START:
      return {
        ...state,
        isGettingNameEnquiry: true,
        getNameEnquirySuccess: false,
        nameEnquiry: {},
        error: null,
      };
    case types.GET_NAME_ENQUIRY_SUCCESS:
      return {
        ...state,
        isGettingNameEnquiry: false,
        getNameEnquirySuccess: true,
        nameEnquiry: action.payload,
        error: null,
      };
    case types.GET_NAME_ENQUIRY_FAILURE:
      return {
        ...state,
        isGettingNameEnquiry: false,
        getNameEnquirySuccess: false,
        nameEnquiry: {},
        error: action.payload,
      };

    case types.SEND_MANDATE_ADVICE_START:
      return {
        ...state,
        isLoading: true,
        sendMandateAdviceSuccess: false,
        sendMandateAdvice: {},
        error: null,
      };
    case types.SEND_MANDATE_ADVICE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        sendMandateAdviceSuccess: true,
        sendMandateAdvice: action.payload,
        error: null,
      };
    case types.SEND_MANDATE_ADVICE_FAILURE:
      return {
        ...state,
        isLoading: false,
        sendMandateAdviceSuccess: false,
        sendMandateAdvice: {},
        error: action.payload,
      };
    case types.SEND_BALANCE_ENQUIRY_START:
      return {
        ...state,
        isLoading: true,
        sendBalanceEnquirySuccess: false,
        sendBalanceEnquiry: {},
        error: null,
      };
    case types.SEND_BALANCE_ENQUIRY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        sendBalanceEnquirySuccess: true,
        sendBalanceEnquiry: action.payload,
        error: null,
      };
    case types.SEND_BALANCE_ENQUIRY_FAILURE:
      return {
        ...state,
        isLoading: false,
        sendBalanceEnquirySuccess: false,
        sendBalanceEnquiry: {},
        error: action.payload,
      };
    case types.SEND_FUND_TRANSFER_DC_START:
      return {
        ...state,
        isLoading: true,
        sendFundTransferDcSuccess: false,
        sendFundTransferDc: {},
        error: null,
      };
    case types.SEND_FUND_TRANSFER_DC_SUCCESS:
      return {
        ...state,
        isLoading: false,
        sendFundTransferDcSuccess: true,
        sendFundTransferDc: action.payload,
        error: null,
      };
    case types.SEND_FUND_TRANSFER_DC_FAILURE:
      return {
        ...state,
        isLoading: false,
        sendFundTransferDcSuccess: false,
        sendFundTransferDc: {},
        error: action.payload,
      };
    case types.SEND_FUND_TRANSFER_ADVICE_DC_START:
      return {
        ...state,
        isLoading: true,
        sendFundTransferAdviceDcSuccess: false,
        sendFundTransferAdviceDc: {},
        error: null,
      };
    case types.SEND_FUND_TRANSFER_ADVICE_DC_SUCCESS:
      return {
        ...state,
        isLoading: false,
        sendFundTransferAdviceDcSuccess: true,
        sendFundTransferAdviceDc: action.payload,
        error: null,
      };
    case types.SEND_FUND_TRANSFER_ADVICE_DC_FAILURE:
      return {
        ...state,
        isLoading: false,
        sendFundTransferAdviceDcSuccess: false,
        sendFundTransferAdviceDc: {},
        error: action.payload,
      };
    case types.SEND_FUND_TRANSFER_DD_START:
      return {
        ...state,
        isLoading: true,
        sendFundTransferDdSuccess: false,
        sendFundTransferDd: {},
        error: null,
      };
    case types.SEND_FUND_TRANSFER_DD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        sendFundTransferDdSuccess: true,
        sendFundTransferDd: action.payload,
        error: null,
      };
    case types.SEND_FUND_TRANSFER_DD_FAILURE:
      return {
        ...state,
        isLoading: false,
        sendFundTransferDdSuccess: false,
        sendFundTransferDd: {},
        error: action.payload,
      };
    case types.SEND_FUND_TRANSFER_ADVICE_DD_START:
      return {
        ...state,
        isLoading: true,
        sendFundTransferAdviceDdSuccess: false,
        sendFundTransferAdviceDd: {},
        error: null,
      };
    case types.SEND_FUND_TRANSFER_ADVICE_DD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        sendFundTransferAdviceDdSuccess: true,
        sendFundTransferAdviceDd: action.payload,
        error: null,
      };
    case types.SEND_FUND_TRANSFER_ADVICE_DD_FAILURE:
      return {
        ...state,
        isLoading: false,
        sendFundTransferAdviceDdSuccess: false,
        sendFundTransferAdviceDd: {},
        error: action.payload,
      };
    case types.SEND_AMOUNT_BLOCK_START:
      return {
        ...state,
        isLoading: true,
        sendAmountBlockSuccess: false,
        sendAmountBlock: {},
        error: null,
      };
    case types.SEND_AMOUNT_BLOCK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        sendAmountBlockSuccess: true,
        sendAmountBlock: action.payload,
        error: null,
      };
    case types.SEND_AMOUNT_BLOCK_FAILURE:
      return {
        ...state,
        isLoading: false,
        sendAmountBlockSuccess: false,
        sendAmountBlock: {},
        error: action.payload,
      };
    case types.SEND_ACCOUNT_BLOCK_START:
      return {
        ...state,
        isLoading: true,
        sendAccountBlockSuccess: false,
        sendAccountBlock: {},
        error: null,
      };
    case types.SEND_ACCOUNT_BLOCK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        sendAccountBlockSuccess: true,
        sendAccountBlock: action.payload,
        error: null,
      };
    case types.SEND_ACCOUNT_BLOCK_FAILURE:
      return {
        ...state,
        isLoading: false,
        sendAccountBlockSuccess: false,
        sendAccountBlock: {},
        error: action.payload,
      };
    case types.GET_FINANCIAL_LIST_START:
      return {
        ...state,
        isLoading: true,
        getFinancialListSuccess: false,
        getFinancialList: {},
        error: null,
      };
    case types.GET_FINANCIAL_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        getFinancialListSuccess: true,
        getFinancialList: action.payload,
        error: null,
      };
    case types.GET_FINANCIAL_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        getFinancialListSuccess: false,
        getFinancialList: {},
        error: action.payload,
      };
    case types.CLEAR_INWARD_INTERACTION_STATE:
      return initialState;
    default:
      return state;
  }
};
